import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  AdditionalOptions,
  buildDynamicDownloadUrl,
  downloadImage,
  DownloadOptions,
  Option,
} from "../Utilities";
import { green, red } from "@mui/material/colors";
import InfoIcon from "@mui/icons-material/Info";

export default function TemplateRowForm(options: DownloadOptions) {
  let [extensionOptions, setExtensionOptions] = useState<Option[]>([
    { label: "jpg", id: 1 },
    { label: "png", id: 2 },
  ]);
  let [colorOptions, setColorOptions] = useState<Option[]>([
    { label: "srgb", id: 1 },
    { label: "p3", id: 2 },
    { label: "cmyk", id: 3 },
  ]);
  let [dynamicUrl, setDynamicUrl] = useState<string | null>(null);

  const [formValues, setFormValues] = useState<AdditionalOptions>({
    extension: extensionOptions[0].label,
    color: colorOptions[0].label,
    maxFileSize: "",
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      "&:hover": {
        bgcolor: green[700],
      },
    }),
    ...(error && {
      bgcolor: red[500],
      "&:hover": {
        bgcolor: red[700],
      },
    }),
  };

  // Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    downloadCrop();
  };

  function downloadCrop() {
    (async () => {
      try {
        let dynamicUrl = await buildDynamicDownloadUrl(options, formValues);
        setDynamicUrl(dynamicUrl);
      } catch (error) {
        console.log("Error during buildDynamicDownloadUrl: " + error);
        setError(true);
        setSuccess(false);
        setLoading(false);
        setErrorMessage(error);
      }
    })();
  }

  function downloadDynamicUrl() {
    console.log("Starting downloadImage...");
    downloadImage(dynamicUrl, options.uuid, options.template);
    setLoading(false);
    setSuccess(true);
    setError(false);
    setErrorMessage(null);
    setDynamicUrl(null);
  }

  useEffect(() => {
    //ogni volta che dynamicUrl cambia avviamo il download
    if (dynamicUrl) {
      downloadDynamicUrl();
    }
  }, [dynamicUrl]);

  return (
    <FormControl component="form" onSubmit={handleSubmit}>
      <Stack spacing={5} direction="row">
        <TextField
          id="extension"
          select
          //defaultValue={extensionOptions[0]}
          SelectProps={{
            native: true,
          }}
          variant="standard"
          value={formValues.extension}
          onChange={handleChange}
          sx={{ marginTop: "15px !important", width: "90px" }}
        >
          {extensionOptions.map((option) => (
            <option key={option.id} value={option.label}>
              {option.label}
            </option>
          ))}
        </TextField>

        <TextField
          id="color"
          select
          //defaultValue={colorOptions[0]}
          SelectProps={{
            native: true,
          }}
          value={formValues.color}
          onChange={handleChange}
          variant="standard"
          sx={{ marginTop: "15px !important", width: "90px" }}
        >
          {colorOptions.map((option) => (
            <option key={option.id} value={option.label}>
              {option.label}
            </option>
          ))}
        </TextField>

        <TextField
          id="maxFileSize"
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">kB</InputAdornment>,
          }}
          variant="standard"
          label="Max File Size"
          value={formValues.maxFileSize}
          onChange={(e) => {
            const value = parseFloat(e.target.value);
            if (value >= 0) {
              handleChange(e); // Call your original handler if value is valid
            } else {
              handleChange({ ...e, target: { ...e.target, value: 0 } }); // Reset to 0 if value is negative
            }
          }}
        />
        <Box sx={{ m: 1, position: "relative" }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={buttonSx}
            disabled={loading}
          >
            Download
          </Button>
          {loading && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px",
              }}
            />
          )}
        </Box>

        <div
          className={`mt-auto mb-auto ${
            error == true ? "visible" : "invisible"
          } `}
        >
          <Tooltip title={errorMessage} placement="top-start">
            <InfoIcon color="error" />
          </Tooltip>
        </div>
      </Stack>
    </FormControl>
  );
}
